// extracted by mini-css-extract-plugin
module.exports = {"categories-row--desktop":"_1410bfd27b--categories-row--desktop--k_itM","categories-col--desktop":"_1410bfd27b--categories-col--desktop--spnUt"};